import React from "react";
import malgadi from "../static/media/malgadi.png";
import csi from "../static/media/csi.png";
import simulas from "../static/media/simulas.png";
import krewbee from "../static/media/krewbee.jpeg";
import timelineElements from "../static/info/experienceData";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { useTheme } from "../utils/ThemeContext";

export default function Experience() {
  const { theme } = useTheme();
  return (
    <div className="mt-[65px] p-5 gradient-bg">
      <h1 className="text-2xl sm:text-3xl my-4 font-bold text-center text-heading">
        Work Experience
      </h1>
      <VerticalTimeline>
        {timelineElements.map((element) => {
          let iconName = element.icon;
          return (
            <VerticalTimelineElement
              key={element.key}
              date={element.date}
              dateClassName={`date ${
                theme == "dark" ? "text-gray-400" : "text-content"
              }`}
              icon={
                iconName == "malgadi" ? (
                  <img
                    src={malgadi}
                    className="object-contain rounded-full"
                    width={"100%"}
                    height="auto"
                  />
                ) : iconName == "csi" ? (
                  <img
                    src={csi}
                    className="rounded-full"
                    width={"100%"}
                    height="auto"
                  />
                ) : iconName == "simulas" ? (
                  <img
                    src={simulas}
                    className="rounded-full"
                    width={"100%"}
                    height="auto"
                  />
                ) : (
                  <img
                    src={krewbee}
                    className="rounded-full"
                    width={"100%"}
                    height="auto"
                  />
                )
              }
            >
              <h3 className="font-semibold text-lg vertical-timeline-element-title">
                {element.title}
              </h3>
              <h5 className="vertical-timeline-element-subtitle">
                {element.location}
              </h5>
              <p id="description" className="pl-2">
                <ul>
                  {element.description.map((item, index) => (
                    <li className="list-disc" key={index}>
                      {item}
                    </li>
                  ))}
                </ul>
              </p>
            </VerticalTimelineElement>
          );
        })}
      </VerticalTimeline>
    </div>
  );
}
